import { select } from 'redux-saga/effects';
import fetchData from '../../api/fetchData';
import {
  TYPES,
  TEMPLATE_TYPES,
  CHAIN_SERVICES,
  TEMPLATES_SEARCH,
} from '../../consts/chains';
import getQueryString from '../../utils/getQueryString';
import { safeCall } from './errors';

const PERSONS_API_URL = `${process.env.API_URL}/mail_templates`;

const templateKindSelector = ({
  chains: { isCreate, activeChain, newChainType },
}) => {
  if (isCreate) {
    return newChainType !== CHAIN_SERVICES.EMAIL
      ? TEMPLATE_TYPES.MESSENGER
      : TEMPLATE_TYPES.EMAIL;
  }

  return activeChain?.type === TYPES.MAIL
    ? TEMPLATE_TYPES.EMAIL
    : TEMPLATE_TYPES.MESSENGER;
};

export function* fetchMailTemplatesGroups() {
  const kind = yield select(templateKindSelector);

  const apiUrl = `${PERSONS_API_URL}/groups?kind=${kind}`;
  return yield safeCall(fetchData, apiUrl);
}

export function* fetchMailTemplates({ payload: { groupId } }) {
  const kind = yield select(templateKindSelector);

  const apiUrl = `${PERSONS_API_URL}?group_id=${groupId}&kind=${kind}`;
  return yield safeCall(fetchData, apiUrl);
}

export function* fetchMailTemplatesSearch({ query }) {
  const kind = yield select(templateKindSelector);
  const params = new URLSearchParams({
    q: query.trim(),
    kind,
    size: String(TEMPLATES_SEARCH.PAGE_SIZE),
  });

  return yield safeCall(fetchData, `${PERSONS_API_URL}/search?${params}`);
}

export function* fetchMailTemplate({ payload: { templateId } }) {
  const activeManager = yield select(({ general }) => general.currentManager);
  const activeTicket = yield select(({ tickets }) => tickets.activeTicket);
  const kind = yield select(templateKindSelector);

  const { ownOrders } = activeTicket;

  const params = {
    manager_id: activeManager.id,
    kind,
    client_id: activeTicket.client.id,
  };

  if (ownOrders && ownOrders.length > 0) {
    params.order_id = ownOrders[0].id;
  }

  const apiUrl = `${PERSONS_API_URL}/${templateId}?${getQueryString(params)}`;
  return yield safeCall(fetchData, apiUrl);
}
